import { createRolePending, createRoleSuccess, createRoleFail } from "./userRoleSlice";
import { userRoleCreation } from "../../../api/userApi";
// export const newUserRoleCreation = (frmDt) => async (dispatch) => {
   
//     try {
//         dispatch(createRolePending());
//         const result = await userRoleCreation(frmDt);
//         result.status === "success"
//             ? dispatch(createRoleSuccess(result))
//             : dispatch(createRoleFail(result.message));

//             console.log("userRoleCreation "+result);
//             // console.log("try block");
//             console.log(result.status);
//             console.log('actions '+result.message);

//     } catch (error) {
//         // console.log("catch block");
//         const err = JSON.parse(JSON.stringify(error.response.data.error));
     
//         dispatch(createRoleFail(err.msg));
//     }

// }


export const newUserRoleCreation = (frmDt) => async (dispatch) => {
    try {
      dispatch(createRolePending());
      const result = await userRoleCreation(frmDt);
      if (result.status === "success") {
        dispatch(createRoleSuccess(result));
        return result; // Return the response for access in handleOnSubmit
      } else {
        dispatch(createRoleFail(result.message));
        throw new Error(result.message); // Throw an error for error handling in handleOnSubmit
      }
    } catch (error) {
      const err = JSON.parse(JSON.stringify(error.response.data.error));
      dispatch(createRoleFail(err.msg));
      throw error; // Rethrow the error for error handling in handleOnSubmit
    }
  };
  
